import { useTranslation } from "react-i18next";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const useHomeFaqs = () => {
  const { t } = useTranslation();
  return (t("homeFaq.questions", { returnObjects: true }) as {
    question: string;
    answer: string;
  }[]).filter((q) => q && q.question);
};

const HomeFaq = () => {
  const { t } = useTranslation();
  const faqs = useHomeFaqs();

  return (
    <section id="faq" className="py-16 sm:py-24 bg-secondary/20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-12">
        <div className="max-w-5xl mx-auto">
          <div className="border-t border-border/40 pt-8 mb-12">
            <h2 className="text-2xl sm:text-3xl font-bold text-foreground">
              {t("homeFaq.title")}
            </h2>
          </div>

          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="border border-border/40 rounded-xl px-6 bg-background hover:border-primary/30 transition-colors"
              >
                <AccordionTrigger className="text-left text-lg font-semibold text-foreground hover:text-primary py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed pb-6 text-justify hyphens-none">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default HomeFaq;
